import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [{
		path: '*',
		redirect: '/'
	}, {
		path: '/',
		name: 'PageView',
		component: resolve => require(['@/view/PageView'], resolve),
		children: [{
				path: '/',
				redirect: '/home'
			}, {
				path: '/home',
				name: 'home',
				component: resolve => require(['@/view/HomePage'], resolve),
				meta: {
					title: '首页'
				}
			}, {
				path: '/watch',
				name: 'watch',
				component: resolve => require(['@/view/watch'], resolve),
				meta: {
					title: '核心业务'
				}
			}, {
				path: '/companyintroduction',
				name: 'companyintroduction',
				component: resolve => require(['@/view/CompanyIntroduction'], resolve),
				meta: {
					title: '新闻动态'
				}
			}, {
				path: '/phone',
				name: 'phone',
				component: resolve => require(['@/view/phone'], resolve),
				meta: {
					title: '关于我们'
				}
			},
			{
				path: '/publicWelfare',
				name: 'publicWelfare',
				component: resolve => require(['@/view/publicWelfare'], resolve),
				meta: {
					title: '农夫铺子公益'
				}
			},
			{
				path: '/message',
				name: 'message',
				component: resolve => require(['@/view/message'], resolve),
				meta: {
					title: '留言板'
				}
			},
			{
				path: '/newsDetail',
				name: 'newsDetail',
				component: resolve => require(['@/view/newsDetail'], resolve),
				meta: {
					title: '新闻详情'
				}
			}
		]
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js